import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import SplineChart from "./SplineChart";
import { api, endpoint } from "../../api";
import { Spin } from "antd";

const LineChart = ({ data, isLoading = false, setIsLoading }) => {
  const { userDetails } = useSelector((state) => state.user);
  const [graphData, setGraphData] = useState([])

  console.log("line", { data })


  const { chartType, chartTitle, locations, xAxis } = data

  // get device data
  const getDeviceChartData = async () => {
    const body = { device: locations[0].device, yAxis: locations[0].yAxis, unit: xAxis.unit }
    const data = await api.get(endpoint.get_device_chart, {
      params: body,
    })
    console.log({ data })
    if (data.success) {
      setGraphData(data?.results)
    }
    setIsLoading(false)
  }
  // get location data
  const getLocationChartData = async () => {
    const body = locations.map(item => ({ location: item.location, yAxis: item.yAxis }))
    const data = await api.get(endpoint.get_location_chart, {
      params: { locations: body },
    })
    if (data.success) {
      setGraphData(data?.results)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    setIsLoading(true)
    if (chartType === 'Device Chart') {
      getDeviceChartData()
    } else {
      getLocationChartData()
    }

  }, [chartType])


  return (
    <div className="p-3">
      <Spin spinning={isLoading}>
        {
          graphData.length > 0 ? <SplineChart
            title={chartTitle}
            data={graphData}
            chartType={chartType}
            type="spline"
          /> : 'No Data Found'
        }
      </Spin>

    </div>
  );
};

export default LineChart;
